import { render, staticRenderFns } from "./BAMFrictionStandardization.vue?vue&type=template&id=7431e254&"
import script from "./BAMFrictionStandardization.vue?vue&type=script&lang=js&"
export * from "./BAMFrictionStandardization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports